import { useState } from 'react';
import { compose, F, T, tap } from 'ramda';

import ReportsTile from '../../shared/ReportsTile';
import { selectSelectedCompany } from 'companies/companies.slice';
import { useSelector } from 'react-redux';
import { downloadAcceptanceReceivedReport } from 'shared/api/acceptanceReceivedApi';
import { useErrorNotifier } from 'shared/custom-hooks/useNotifiers';

interface AcceptanceReceivedProps {
  serviceType: string;
  description: string;
  startDate: string | null;
  endDate: string | null;
  count: number | null;
}

function AcceptanceReceived({ serviceType, description, startDate, endDate, count }: AcceptanceReceivedProps) {
  const [ downloading, setDownloading ] = useState(false);
  const doneDownloading = compose(setDownloading, F);
  const startDownloading = compose(setDownloading, T);

  const errorNotifier = useErrorNotifier();
  const handleError = compose(tap(doneDownloading), errorNotifier);

  const { compid } = useSelector(selectSelectedCompany) ?? { compid: 0 };

  function handleExport() {
    startDownloading();
    downloadAcceptanceReceivedReport(compid, serviceType, startDate ?? undefined, endDate ?? undefined)
      .then(doneDownloading)
      .catch(handleError);
  }

  return (
    <ReportsTile
      count={count}
      title="Acceptances Received"
      description={description}
      exportDisabled={count === null || !startDate || !endDate}
      onExport={handleExport}
      downloading={downloading}
    />
  );
}

export default AcceptanceReceived;
